var React = require('react');

function LinkedIn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28.7361 29.3893V29.3882H28.7426V19.5895C28.7426 14.796 27.7333 11.1034 22.2526 11.1034C19.6179 11.1034 17.8498 12.5817 17.128 13.9833H17.0518V11.5509H11.8552V29.3882H17.2662V20.5558C17.2662 18.2303 17.6974 15.9815 20.5139 15.9815C23.2891 15.9815 23.3305 18.6355 23.3305 20.705V29.3893H28.7361Z","fill":"#8086F2","key":0}),React.createElement("path",{"d":"M3.04407 11.552H8.46161V29.3893H3.04407V11.552Z","fill":"#8086F2","key":1}),React.createElement("path",{"d":"M5.75071 2.67175C4.01853 2.67175 2.61298 4.10893 2.61298 5.88008C2.61298 7.65123 4.01853 9.11847 5.75071 9.11847C7.48288 9.11847 8.88844 7.65123 8.88844 5.88008C8.88735 4.10893 7.48179 2.67175 5.75071 2.67175V2.67175Z","fill":"#8086F2","key":2})]);
}

LinkedIn.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none"};

module.exports = LinkedIn;

LinkedIn.default = LinkedIn;
